import * as React from "react";
const SvgFiRrSpeedometerKpi = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-speedometer-kpi_svg__a)">
      <path
        fill="#062147"
        d="M5.918 11.986a1 1 0 0 1-.821-1.151A6.974 6.974 0 0 1 12 5q.59 0 1.166.097a1 1 0 0 1 .82 1.152.995.995 0 0 1-1.152.82A5 5 0 0 0 12 7a4.98 4.98 0 0 0-4.931 4.165c-.082.489-.672.821-1.151.821m2.648 7.448 1.25-2.22a.815.815 0 0 0-1.413-.813l-1.449 2.465H6.6v-2.067a.8.8 0 1 0-1.6 0v6.4a.8.8 0 1 0 1.6 0v-2.733h.612l1.378 3.057a.808.808 0 0 0 1.478-.656zm-2.648-7.448c-.055 0 .056.009 0 0M12 0C5.383 0 0 5.383 0 12c0 1.746.367 3.431 1.092 5.007a1 1 0 1 0 1.816-.836A9.9 9.9 0 0 1 2 12C2 6.486 6.486 2 12 2s10 4.486 10 10a9.9 9.9 0 0 1-.872 4.09 1 1 0 0 0 1.824.82A11.9 11.9 0 0 0 24 12c0-6.617-5.383-12-12-12m2 12c0-.189-.035-.368-.083-.541l3.786-3.749a1 1 0 1 0-1.406-1.421l-3.814 3.776A2 2 0 0 0 12 10a2 2 0 1 0 2 2m3.8 4a.8.8 0 0 0-.8.8v6.4a.8.8 0 1 0 1.6 0v-6.4a.8.8 0 0 0-.8-.8m-1.701 2.5a2.5 2.5 0 0 1-2.5 2.5h-.5v2.2a.8.8 0 1 1-1.6 0v-6.4a.8.8 0 0 1 .8-.8h1.3a2.5 2.5 0 0 1 2.5 2.5m-1.522 0c0-.551-.449-1-1-1h-.555v2h.555c.551 0 1-.449 1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-speedometer-kpi_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSpeedometerKpi;
